/**
 * EL BESO DE FRUTA - LUXURY & STERNIFY CRO ENGINE
 * Vanilla JavaScript Utilities & DOM Event Bus
 */

(function () {
  'use strict';

  // Global Quick Add to Cart helper
  window.quickAddToCart = async function (buttonElement, variantId, quantity = 1) {
    if (!variantId) return;

    const originalText = buttonElement ? buttonElement.innerHTML : '';
    if (buttonElement) {
      buttonElement.disabled = true;
      buttonElement.innerHTML = `
        <span style="display:inline-block;animation:spin 0.8s linear infinite;">⏳</span>
      `;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(quantity, 10) || 1
        })
      });

      const itemData = await response.json().catch(() => ({}));

      if (!response.ok) {
        const errorMsg = itemData.description || itemData.message || 'No disponible';
        const isSoldOut = errorMsg.toLowerCase().includes('stock') || errorMsg.toLowerCase().includes('sold') || errorMsg.toLowerCase().includes('agotado') || response.status === 422;
        throw new Error(isSoldOut ? 'Agotado' : errorMsg);
      }

      // Show success feedback
      if (buttonElement) {
        buttonElement.innerHTML = `✓ ¡Añadido!`;
        setTimeout(() => {
          buttonElement.innerHTML = originalText;
          buttonElement.disabled = false;
        }, 1800);
      }

      // Dispatch global cart:updated event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { item: itemData }
      }));

      await refreshCartUI();
    } catch (error) {
      console.warn('Error adding to cart:', error.message);
      if (buttonElement) {
        buttonElement.innerHTML = error.message === 'Agotado' ? `Agotado ⚠️` : `Error ⚠️`;
        setTimeout(() => {
          buttonElement.innerHTML = originalText;
          buttonElement.disabled = false;
        }, 2200);
      }
    }
  };

  // Helper to re-render drawer and update cart count
  async function refreshCartUI() {
    const drawerComponent = document.querySelector('cart-drawer-component');
    if (drawerComponent) {
      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const res = await fetch(`${rootUrl}?section_id=cart-drawer-section`);
        if (res.ok) {
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('cart-drawer-component');
          if (newContent) {
            drawerComponent.innerHTML = newContent.innerHTML;
          }
        }
      } catch (e) {
        console.warn('Could not refresh cart drawer:', e);
      }
    }

    try {
      const cartRes = await fetch('/cart.js');
      if (cartRes.ok) {
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count, [data-cart-count], .cart-bubble, cart-count').forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
            el.classList.remove('hidden');
          }
        });
      }
    } catch (e) {}

    const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      const drawerTrigger = document.querySelector('[aria-controls="cart-drawer"], [href="/cart"]');
      if (drawerTrigger && drawerTrigger.getAttribute('aria-controls') === 'cart-drawer') {
        drawerTrigger.click();
      }
    }
  }

  // Global Add Bundle / Mix & Match helper
  window.addBundleToCart = async function (buttonElement, variantId, properties = {}, quantity = 1) {
    if (!variantId) {
      console.error('No variant ID provided for bundle');
      return false;
    }

    const originalText = buttonElement ? buttonElement.innerHTML : '';
    if (buttonElement) {
      buttonElement.disabled = true;
      buttonElement.innerHTML = `
        <span style="display:inline-block;animation:spin 0.8s linear infinite;">⏳</span> Añadiendo Pack...
      `;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: parseInt(quantity, 10) || 1,
          properties: properties
        })
      });

      const itemData = await response.json().catch(() => ({}));

      if (!response.ok) {
        const errorMsg = itemData.description || itemData.message || 'No disponible';
        throw new Error(errorMsg);
      }

      if (buttonElement) {
        buttonElement.innerHTML = `✓ ¡Pack Añadido con Éxito!`;
        setTimeout(() => {
          buttonElement.innerHTML = originalText;
          buttonElement.disabled = false;
        }, 2000);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { item: itemData }
      }));

      await refreshCartUI();
      return true;
    } catch (err) {
      console.warn('Error adding bundle:', err);
      if (buttonElement) {
        buttonElement.innerHTML = `No se pudo añadir ⚠️`;
        setTimeout(() => {
          buttonElement.innerHTML = originalText;
          buttonElement.disabled = false;
        }, 2400);
      }
      return false;
    }
  };

  // Pre-checkout coupon apply helper
  window.applyCartDiscount = async function (inputElement, buttonElement) {
    const code = inputElement ? inputElement.value.trim() : '';
    if (!code) return;

    const originalText = buttonElement.innerText;
    buttonElement.disabled = true;
    buttonElement.innerText = '...';

    try {
      await fetch(`/discount/${encodeURIComponent(code)}`);
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'DiscountCode': code }
        })
      });

      buttonElement.innerText = '¡Aplicado!';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(() => {
        buttonElement.innerText = originalText;
        buttonElement.disabled = false;
      }, 2000);
    } catch (err) {
      console.error('Error applying discount:', err);
      buttonElement.innerText = 'Error';
      setTimeout(() => {
        buttonElement.innerText = originalText;
        buttonElement.disabled = false;
      }, 1500);
    }
  };

})();
